import React, { FunctionComponent, ChangeEventHandler } from 'react';
import {dispatchWithoutTaxePriceHandleClick} from "@/animations/responsive/productPageTracking";

interface Props {
  side: string;
  size: string;
  field: string;
  checked: boolean;
  callBack: (checked: boolean, field: string) => void;
  enabled?: boolean;
  children: JSX.Element
}

export const Toggle: FunctionComponent<Props> = ({
  side,
  size,
  field,
  checked,
  callBack,
  enabled = true,
  children,
}) => {

  const toggleSide = side || 'left';
  const toggleSize = size || 'big';

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (!enabled) return;
    callBack(e.target.checked, field);
    if (e.target.checked) {
      dispatchWithoutTaxePriceHandleClick()
    }

  }

  return (
    <label
      htmlFor={field}
      className={`toggle ${toggleSide} ${toggleSize} ${checked ? 'checked' : ''} ${!enabled ? 'disabled' : ''}`}
    >
      {toggleSide === 'right' && <span className="label">{children}</span>}
      <div className="toggleBlock">
        <div className="togglePin" />
      </div>
      {toggleSide === 'left' && <span className="label">{children}</span>}
      <input
        type="checkbox"
        id={field}
        checked={checked}
        disabled={!enabled}
        onChange={handleChange}
      />
    </label>
  )
}